import React from "react";
import PillarTableBodyRows from "shared/components/pillar-table/body/PillarTableBodyRows";
import PillarTableEmptyTable from "shared/components/pillar-table/body/PillarTableEmptyTable";
import PillarTableError from "shared/components/pillar-table/body/PillarTableError";
import PillarTableSpinner from "shared/components/pillar-table/body/PillarTableSpinner";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { type PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";

const PillarTableBody = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>() => {
  const { testidTable, isInfinityTable, totalTableHeight } =
    usePillarTableContext<
      RowGeneric,
      ExtraPropsGeneric,
      InlineEditFormGeneric
    >();
  return (
    <tbody
      data-testid={testidTable ? `${testidTable}-table-body` : undefined}
      className={isInfinityTable ? "relative w-full translate-x-0" : ""}
      style={
        isInfinityTable
          ? {
              height: `${totalTableHeight}px`,
            }
          : undefined
      }
    >
      <PillarTableSpinner />
      <PillarTableError />
      <PillarTableEmptyTable />
      <PillarTableBodyRows<
        RowGeneric,
        ExtraPropsGeneric,
        InlineEditFormGeneric
      > />
    </tbody>
  );
};

export default PillarTableBody;
